import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const adminApi = axios.create({
  baseURL: `${API_URL}/api`,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Admin Auth
export const adminLogin = (email, password) => 
  adminApi.post('/admin/login', { email, password });

// Admin Products
export const adminGetProducts = () => adminApi.get('/admin/products');
export const adminCreateProduct = (data) => adminApi.post('/admin/products', data);
export const adminUpdateProduct = (id, data) => adminApi.put(`/admin/products/${id}`, data);
export const adminDeleteProduct = (id) => adminApi.delete(`/admin/products/${id}`);

// Admin Analytics
export const adminGetAnalytics = () => adminApi.get('/admin/analytics');

// Track Click (public)
export const trackAffiliateClick = (productId) => 
  axios.post(`${API_URL}/api/track-click/${productId}`, {}, {
    headers: {
      Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    }
  });

export default adminApi;
